import React from 'react';
import PropTypes from 'prop-types';
import EventTemplateDropdown from './EventTemplateDropdown';
import SaveEventTemplateDropdown from './SaveEventTemplateDropdown';

// O-5024: the show's template controls, at the top of every editor surface —
// complex, mobile and simple. One event template carries both the offer template
// and the budget template, so this replaced the pair of budget-template controls
// that used to sit inside the Income section.
const EventTemplateBar = ({
  team,
  csrfToken,
  budget,
  eventTemplates,
  onApplyTemplate,
  onTemplateCreated,
  onTemplateSaved,
  onBudgetPatched,
}) => {
  // useV3OfferBudget returns {} — not null — when there is no budget, so guard on
  // the id: a bar rendered without one would post to /budgets/v3/undefined and
  // silently mint an empty template.
  if (!budget?.id) return null;

  const current = eventTemplates.find((t) => t.value === budget.event_template_id);

  return (
    <div className="event-template-bar" data-testid="event-template-bar">
      <EventTemplateDropdown
        team={team}
        csrfToken={csrfToken}
        budget={budget}
        eventTemplates={eventTemplates}
        onApplyTemplate={onApplyTemplate}
      />
      <SaveEventTemplateDropdown
        team={team}
        csrfToken={csrfToken}
        budget={budget}
        currentTemplateName={current?.label}
        offerTemplateId={current?.offerTemplateId}
        onTemplateCreated={onTemplateCreated}
        onTemplateSaved={onTemplateSaved}
        onBudgetPatched={onBudgetPatched}
      />
    </div>
  );
};

EventTemplateBar.propTypes = {
  team: PropTypes.object.isRequired,
  csrfToken: PropTypes.string.isRequired,
  budget: PropTypes.object,
  eventTemplates: PropTypes.array,
  onApplyTemplate: PropTypes.func,
  onTemplateCreated: PropTypes.func,
  onTemplateSaved: PropTypes.func,
  onBudgetPatched: PropTypes.func,
};

EventTemplateBar.defaultProps = {
  budget: null,
  eventTemplates: [],
  onApplyTemplate: null,
  onTemplateCreated: null,
  onTemplateSaved: null,
  onBudgetPatched: null,
};

export default EventTemplateBar;
